import Navbar from './components/home/Navbar';
import LeftSidebar from './components/home/LeftSidebar';
import { BrowserRouter, Route, Router, Routes } from 'react-router-dom';
import { useEffect, useState } from 'react';
import MapComponent from './pages/Map';
import Staff from './pages/Staff';
import Documents from './pages/Documents';
import Downloads from './pages/Downloads';
import Noticias from './pages/Noticias';
import Extratos from './pages/Extratos';
import TransferenciasGlobais from './pages/TransferenciasGlobais';
import Municipios from './pages/Municipios';
import NoticiasPeriodo from './pages/noticias/NoticiasPeriodo';
import Faqs from './pages/Faqs';
import Historicos from './pages/Historicos';
import Legislacoes from './pages/Legislacoes';
import Acordos from './pages/Acordos';
import FaqsCategoria from './pages/FaqsCategoria';
import ExtratosRelatorio from './pages/ExtratoRelatorio';
import ExtratoAnual from './pages/ExtratoAnual';
import ExtratoComparativoTransferencia from './pages/ExtratoComparativoTransferencia';
import Footer from 'components/home/Footer';
import Pesquisas from 'pages/Pesquisas';
import ExtratoComparativoIndice from 'pages/ExtratoComparativoIndice';
import ModalComponent from 'components/ModalComponent';
import Parceiros from 'pages/Parceiros';
import Contatos from 'pages/Contatos';
import ChatBot from 'pages/Chatbot';

export default function App() {

  const isMobile = () => {
    const regex = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    return regex.test(navigator.userAgent);
  }

  useEffect(() => {

    const zoomInicial = document.body.style.zoom;
    const larguraTela = window.innerWidth;

    if (isMobile()) {
      document.getElementById('buttonAvisoMobile').click();
      document.body.style.zoom = "60%";
      document.getElementById('leftsidebar').style.height = '100%';

    } else {
      if (larguraTela < 1450) {
        document.body.style.zoom = "75%";
        document.getElementById('leftsidebar').style.height = '100%';
      }
    }


    return () => {
      document.body.style.zoom = zoomInicial;
    };

  }, []);

  useEffect(() => {
    var _paq = window._paq = window._paq || [];
    _paq.push(['trackPageView']);
    _paq.push(['enableLinkTracking']);
    (function () {
      var u = "//analytics.fjp.mg.gov.br/";
      _paq.push(['setTrackerUrl', u + 'matomo.php']);
      _paq.push(['setSiteId', '17']);
      var d = document, g = d.createElement('script'), s = d.getElementsByTagName('script')[0];
      g.async = true; g.src = u + 'matomo.js'; s.parentNode.insertBefore(g, s);
    })();
  }, []);

  return (
    <>
      <Navbar />
      <LeftSidebar />
      {/* <!-- Right Sidebar --> */}
      <Routes>
        <Route path='/' element={<Extratos />} />
        <Route path='/extratos' element={<Extratos />} />
        <Route path='/transferenciasglobais' element={<TransferenciasGlobais />} />
        <Route path='/sobre' element={<Staff />} />
        <Route path='/noticias' element={<Noticias />} />
        <Route path='/noticias/periodo' element={<NoticiasPeriodo />} />
        <Route path='/map' element={<MapComponent />} />
        <Route path='/downloads' element={<Downloads />} />
        <Route path='/staff' element={<Staff />} />
        <Route path='/documentos' element={<Documents />} />
        <Route path='/municipios' element={<Municipios />} />
        <Route path='/faqs' element={<Faqs />} />
        <Route path='/faqscategoria' element={<FaqsCategoria />} />
        <Route path='/historicos' element={<Historicos />} />
        <Route path='/legislacoes' element={<Legislacoes />} />
        <Route path='/acordos' element={<Acordos />} />
        <Route path='/extratos/relatorio' element={<ExtratosRelatorio />} />
        <Route path='/extratos/anual' element={<ExtratoAnual />} />
        <Route path='/extratos/comparativo/transferencia' element={<ExtratoComparativoTransferencia />} />
        <Route path='/extratos/comparativo/indice' element={<ExtratoComparativoIndice />} />
        <Route path='/pesquisas' element={<Pesquisas />} />
        <Route path='/parceiros' element={<Parceiros />} />
        <Route path='/contatos' element={<Contatos />} />
        <Route path='/chatbot' element={<ChatBot />} />
        <Route path='*' element={<Historicos />} />
      </Routes>
      <Footer />

      <ModalComponent titulo={<><i class="zmdi zmdi-alert-triangle text-warning"></i> AVISO </>} modalId={'avisoMobile'}>
        <p>Esta aplicação ainda não se encontra totalmente otimizada para acesso em dispositivos moveis</p>
        <p>Para uma melhor experiência favor considerar o acesso utlizando um Computador/Notebook.</p>
      </ModalComponent >
      <a href='' data-toggle='modal' data-target='#avisoMobile' className='small text-white' id='buttonAvisoMobile' style={{ display: 'none' }}></a>
    </>
  );
}
